import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/* Exception-only status treatment (design system §status):
   healthy/default states render as a neutral dot + text; only exceptions get tinted pills */
const NEUTRAL_STATES = {
  available: ["Available", "bg-emerald-500"],
  active: ["Active", "bg-emerald-500"],
  on_hire: ["On Hire", "bg-accent-icon"],
  mobilised: ["Mobilised", "bg-accent-icon"],
};
const EXCEPTION_STYLES = {
  stand_down: "bg-red-50 text-red-700",
  maintenance: "bg-amber-50 text-amber-800",
  off_hire: "bg-surface-pressed text-ink-secondary",
  demobilised: "bg-surface-pressed text-ink-secondary",
  inactive: "bg-surface-pressed text-ink-secondary",
};

export function StatusBadge({ value }) {
  const v = value || "available";
  if (NEUTRAL_STATES[v]) {
    const [label, dot] = NEUTRAL_STATES[v];
    return (
      <span className="inline-flex items-center gap-1.5 text-cell text-ink-secondary">
        <span className={`w-1.5 h-1.5 rounded-full ${dot}`} /> {label}
      </span>
    );
  }
  const label = (v === "inactive" ? "not active" : v).replace("_", " ");
  return (
    <span className={`inline-block px-1.5 py-0.5 text-pill font-bold uppercase rounded-[4px] ${EXCEPTION_STYLES[v] || "bg-surface-pressed text-ink-secondary"}`}>
      {label}
    </span>
  );
}

// hook: fetch a lookup list -> array of string values
export function useLookup(ltype) {
  const [values, setValues] = useState([]);
  useEffect(() => {
    api.get(`/lookups/${ltype}`).then(({ data }) => setValues(data.map((d) => d.value))).catch(() => {});
  }, [ltype]);
  return values;
}

export function useSuppliers() {
  const [values, setValues] = useState([]);
  useEffect(() => {
    api.get("/suppliers").then(({ data }) => setValues(data.map((d) => d.name))).catch(() => {});
  }, []);
  return values;
}
